import gql from 'graphql-tag';
import { contentUnifiedContentFragment } from './fragments/contentUnifiedContentFragment.fragment';
import { contentUnifiedSpaceFragment } from './fragments/contentUnifiedSpaceFragment.fragment';

export const ContentUnifiedQuery = gql`
	query ContentUnifiedQuery(
		$contentId: ID!
		$spaceKey: String = null
		$versionOverride: Int
		$isSSR: Boolean = false
		$includeAlias: Boolean = false
		$useNewContentTopper: Boolean = false
	) @SLA {
		content(id: $contentId, version: $versionOverride) {
			nodes {
				...contentUnifiedContentFragment
			}
		}
		space(key: $spaceKey) {
			...contentUnifiedSpaceFragment
		}
	}
	${contentUnifiedContentFragment}
	${contentUnifiedSpaceFragment}
`;
